import moment from 'moment';
import Diff = moment.unitOfTime.Diff;

export class DateUtils {
  static today(format = 'DD.MM.YYYY') {
    return moment().format(format);
  }

  public static DATE_FORMAT = 'DD.MM.YYYY';

  static value(value) {
    return moment(value).valueOf();
  }

  static format(input, inputFormat = 'YYYY-MM-DD', format = 'DD.MM.YYYY') {
    return moment(input, inputFormat, true).format(format);
  }

  static isValid(value: string, format = 'DD.MM.YYYY') {
    return moment(value, format, true).isValid();
  }

  static notValid = (value, format?) => !DateUtils.isValid(value, format);

  static isInFuture(value, format = 'DD.MM.YYYY') {
    return moment(value, format, true).isAfter();
  }

  static isAfterThan(value, value2, format1 = 'DD.MM.YYYY') {
    return moment(value, format1, true).isAfter(value2);
  }

  static isBefore(input, inputFormat = 'DD.MM.YYYY') {
    return moment(input, inputFormat, true).isBefore();
  }

  static diffToNow(value, unitOfTime: Diff = 'years') {
    return moment().diff(value, unitOfTime);
  }

  static diff(value, value2, format1 = 'YYYY-MM-DD', format2 = 'YYYY-MM-DD') {
    return moment(value, format1, true).diff(moment(value2, format2, true));
  }

  static fromService(value) {
    return value ? moment(value).format('DD.MM.YYYY') : '';
  }

  static toService(value) {
    return value && this.isValid(value) ? moment(value, 'DD.MM.YYYY', true).format('YYYY-MM-DD') : null;
  }
}
